<section class="title-link-lead" *ngIf="title">
  <div class="container">
    <h2 *ngIf="title">{{ title }}</h2>
    <p *ngIf="lead" [innerHTML]="lead"></p>
    <a [href]="link" *ngIf="link && linkTitle">{{ linkTitle }}</a>
  </div>
</section>
